export default __webpack_public_path__ + "assets/models/1dc3890285fd3ea22a6a98454b14b790.glb";